// §2.6 List row: leading · title + meta · trailing. Renders a button when onClick is given.
// portal (§3.3, HD-9): the Portal profile's low density, t-body at 15/22, 16 px row padding, 44 px minimum.
export default function ListRow({ leading, title, meta, trailing, onClick, current = false, portal = false, ...rest }) {
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag type={onClick ? 'button' : undefined} className={portal ? 'ui ui-row ui-row--portal' : 'ui ui-row'} onClick={onClick} aria-current={current || undefined} {...rest}>
      {leading}
      <span className="ui-row__main"><span className="ui-row__title">{title}</span>{meta && <span className="ui-row__meta">{meta}</span>}</span>
      {trailing && <span className="ui-row__trail">{trailing}</span>}
    </Tag>
  );
}
